/* eslint-disable @typescript-eslint/no-explicit-any */
import { gradeStats, middleGradeStats, healthStats, stats } from 'consts/commonData';

const useGetEachData = (productNumber: number, chartData: any, activeTab?: number) => {
  let statsDifferentProductNumber;

  // 1 - 스포츠  2 - 병원(양방,검진센터) 3 - 한의원용
  // 4 - 기업체  5 - 보건관리 6 - 연구용 7 - 요가, 필라테스
  // 8 - 초등학교  9 - 고등학교
  // 15 - 보건소

  // 기준은 5 - 보건관리

  switch (productNumber) {
    case 8:
      statsDifferentProductNumber = gradeStats;
      break;
    case 9:
      statsDifferentProductNumber = middleGradeStats;
      break;
    case 4:
    case 5:
      statsDifferentProductNumber = stats;
      break;
    default:
      statsDifferentProductNumber = healthStats;
      break;
  }

  const extractDataByKey = (data: any, keys: string[]) => keys.map((key) => data[key] || 0);

  const extractedData = statsDifferentProductNumber.map(({ key, innerKey }) => {
    const data = chartData?.employee?.[key] || {};
    const innerKeyArray = innerKey.map((data) => data.key);

    return extractDataByKey(data, innerKeyArray);
  });

  const extractedActiveData = statsDifferentProductNumber.map(({ key, innerKey }) => {
    const data = activeTab !== undefined ? chartData[activeTab]?.[key] || {} : {};
    const innerKeyArray = innerKey.map((data) => data.key);

    return extractDataByKey(data, innerKeyArray);
  });

  const extractedLabels = statsDifferentProductNumber.map(({ innerKey }) => {
    const innerValueArray = innerKey.map((data) => data.value);

    return innerValueArray;
  });

  return {
    statsDifferentProductNumber,
    extractedData,
    extractedActiveData,
    extractedLabels
  };
};

export default useGetEachData;
